import React from 'react';
import { EmissionResponse } from 'models/MainDashboard/emissionModel.model';
import { SourceCO2eResponse } from 'models/MainDashboard/emissionModelSource.model';
import { EmissionByLocationResponse } from 'models/MainDashboard/locationDashboard.model';
import { YoYEmission } from 'models/MainDashboard/yoyModel.model';
import { CSSProperties } from 'react';
import { ReactComponent as HouseIcon } from 'assets/icons/House.svg';
import { ReactComponent as CarIcon } from 'assets/icons/Car.svg';
import { ReactComponent as PhoneIcon } from 'assets/icons/Phone.svg';
import { ReactComponent as TreeIcon } from 'assets/icons/Tree.svg';
import { InfoDataModel } from 'models/MainDashboard/infoGraphics.model';
import { ContentType } from 'recharts/types/component/Label';
import { SbtiDashboardResponse } from 'models/Sbti/sbtiYoy.model';
import { SbtiTarget } from 'models/Sbti/sbti.model';
import { MetaData } from 'models/MetaData/metaData.model';

export const getLatestYearFromMetadata = (years: MetaData[]): number | undefined => {
  const numericYears = years
    .map((y) => Number(y.value))
    .filter((n) => Number.isFinite(n));
  return numericYears.length ? Math.max(...numericYears) : undefined;
};
export interface BarProps {
  data?: EmissionByLocationResponse;
  fetchEmissionByLocation: Function;
  orgId: number;
  locationId?: string;
  year: number;
  AxisProp?: string;
  XAxisLabel?: ContentType;
  loading?: boolean;
}
export interface MyLineChartProps {
  data?: YoYEmission[];
  isTwoLine?: boolean;
  xPos?: boolean;
  selectedYear?: number;
  targetName?: string;
  maxSbtiValue?: number;
  sbtiDetailsData?: YoYEmission[];
  orgId?: number;
  targetId?: number;
  isProdDashboard?: boolean;
  fetchYoYEmissions: Function;
  locationId?: string;
  height?: number;
  AxisProp?: string;
  unit: string;
  hasDownload?: boolean;
  loading?: boolean;
  yAxisLabel?: string;
}
export interface PieProps {
  data?: EmissionResponse;
  fetchEmissionData: Function;
  orgId: number;
  locationId: string;
  year: number;
}
export interface ScopeProps {
  sourceData?: SourceCO2eResponse;
  scopeData?: EmissionResponse;
  fetchEmissionDataSource: Function;
  orgId: number;
  scopeCategory: string;
  locationId: string;
  year: number;
  loading?: boolean;
}
export const lineData = [
  { name: 'Year 1', value: 40 },
  { name: 'Year 2', value: 75 },
  { name: 'Year 3', value: 60 },
  { name: 'Year 4', value: 90 },
  { name: 'Year 5', value: 80 },
];
export const scopeData = [
  { label: 'All Scope', value: 'All' },
  { label: 'Scope 1', value: 'scope1' },
  { label: 'Scope 2', value: 'scope2' },
  { label: 'Scope 3', value: 'scope3' },
];
export const barData = [
  { name: 'Category A', value: 30 },
  { name: 'Category B', value: 80 },
  { name: 'Category C', value: 45 },
  { name: 'Category D', value: 60 },
  { name: 'Category E', value: 100 },
];
export const pieData = [
  {
    fuel_name: 'diesel',
    total_co2e: 32.92075,
    percentage: 60,
  },
  {
    fuel_name: 'petrol',
    total_co2e: 0.22075,
    percentage: 10,
  },
  {
    fuel_name: 'petrol',
    total_co2e: 0.22075,
    percentage: 10,
  },
  {
    fuel_name: 'petrol',
    total_co2e: 0.22075,
    percentage: 10,
  },
  {
    fuel_name: 'petrol',
    total_co2e: 0.22075,
    percentage: 10,
  },
];

export const sourceData = [
  { name: 'Scope 1', value: 40 },
  { name: 'Scope 2', value: 20 },
  { name: 'Scope 3', value: 10 },
  { name: 'Scope 4', value: 10 },
  { name: 'Scope 5', value: 20 },
];
export const SourceColors = [
  '#015CA3',
  '#628D9D',
  '#8BB5D5',
  '#2F5E5A',
  '#023257',
  '#c94b5a',
];
export const COLORS = ['#015CA3', '#628D9D', '#8BB5D5'];
export const customFillColor = 'Green';
export const customStyle = { cursor: 'pointer', outline: 'none' };
export const customPosition = 'insideLeft';
export const customPositionX = 'insideBottom';
export const customStyleAnchor: CSSProperties = {
  textAnchor: 'middle',
  fill: '#333',
};
export const customFontTick = { fontSize: 12 };
export const customMarginLineChart = {
  top: 40,
  right: 29,
  bottom: 70,
  left: 30,
};
export const customMarginBar = { top: 70, right: 39, bottom: 100, left: 45 };
export const Linear = 'linear';
export const dataKeyPercentage = 'percentage';
export const dataKeyTotal = 'totalCO2e';
export const sbtiFill = '#66939F';
export const fillColor = '#666';
export const BLOB_TYPE = 'blob';
export const JSON_RESPONSE = 'application/json';
export const FILE_RESPONSE = 'application/octet-stream';
export const CompanyDashboardProps = {
  LABEL_VALUE: 'Emissions ',
  LOCATIONCHART: 'LocationChart',
  ORG_YEARS: 'organization_years',
  EMISSIONCHART: 'EmissionsSourceChart',
  EMISSIONSCOPE: 'EmissionsScopeChart',
  YOYCHART: 'YOYChart',
  DASHBOARD: 'Dashboard',
  STEWWI: 'Stewwi',
  LABEL_LIST_DATAKEY: 'value',
  END: 'end',
  MIDDLE: 'middle',
  Linear: 'linear',
  LABEL_LIST_POSITION: 'top',
  BAR_FILL: '#005CA7',
  LOCATION_BAR_FILL: '#66939F',
  LEGEND_TEXT_FILL: '#333333',
  LINE_FILL: '#86899b',
  APPLY: 'Apply',
  RESET: 'Reset',

  YEAR: 'Year',

  TCO2: 'tCO₂e',
  YOY_TEXT: 'Emissions by Year',
  SELECT_TEXT: 'Select',
  DATA_EMPTY: 'Complete activity data entry to view emission details',
  NO_DATA: 'No Data Available',
  ALL: 'All',
  BAR_DATAKEY: 'totalCO2',
  TRUE: 'true',
  BREAKDOWN_TEXT: 'Emissions Breakdown by Scope',
  SelectOrganization: 'Select Organization',
  SelectLocations: 'Select Locations',
  SelectYear: 'Select Year',
  LINE_DATAKEY: 'value',
  LINE_STROKE: '#005CA7',
  TARGET_STROKE: '#66939f',
  SELECT_SCOPES: 'Select Scope',
  LINE_STROKE_WIDTH: 2,
  DIESEL: 'Diesel',
  PETROL: 'Petrol',
  ENGINE: 'Engine',
  GAS: 'Gas',
  CNG: 'Cng',
  PERC: '%',
  SCOPE_TEXT: 'Emissions Breakdown by Scope and Source',
  SELECT_LOC: 'Select Locations',
  SELECT_SCOPE: 'Select Scope',
  TOTAL_CO2: 'Total CO₂e By Organisation and Location',
  INSIDE: 'insideLeft',
  Scope1: 'Scope 1',
  Scope2: 'Scope 2',
  Scope3: 'Scope 3',
  Add_Parent: 'Add Organization',
  Empty: 'No Parent Organization found',
  LOC: 'Location',
  SCOPE_1_VALUE: 'scope1',
  SELECT: 'Select',
  SELECT_TARGET: 'Select Target',
  NOTES: 'notes',

  // EMISSION-INTENSITY 
  INTENSITY_TEXT: 'Emission Intensity', //'Emission Intensity per kg of Product'
  NO_LOCATION_CHOOSEN: 'Please choose a specific location to see emission intensity',
  INTENSITY_CHART: 'EmissionIntensityChart',
  INTENSITY_UNIT: 'kgCO₂e per kg',
  INTENSITY_UNIT_BY_REVENUE: 'kgCO₂e per $',
  INTENSITY_BY_WEIGHT: 'By Total Weight',
  INTENSITY_BY_REVENUE: 'By Total Revenue',
  INTENSITY_TYPE_SELECT_PLACEHOLDER: 'Select Intensity Type',
  MISSING_REVENUE_MESSAGE: 'Please fill in revenue data for year',
};
export const getInfographicData = (infoData?: InfoDataModel) => ({
  electricity: {
    title: "Home's Electricity Use For One Year",
    icon: <HouseIcon />,
    value: infoData?.infographics?.electricityUsed || 0,
  },
  miles: {
    title: 'Powered Passenger Vehicle Miles Driven By An Average Gasoline',

    icon: <CarIcon />,
    value: infoData?.infographics?.kmDriven || 0,
  },
  smartphone: {
    title: 'Number Of Smartphones Charged',

    icon: <PhoneIcon />,
    value: infoData?.infographics?.smartphonesCharged || 0,
  },
  tree: {
    title: 'Tree Seedlings Grown For 10 Years',

    icon: <TreeIcon />,
    value: infoData?.infographics?.treesGrown || 0,
  },
});
